
















import Vue, { PropType } from 'vue'

import { ChatService } from '../../chat/ChatService'
import { chatLayouts } from '../../layout/chat-layouts'
import { ChannelListMessageChannel } from './ChannelListPanel.vue'

export default Vue.extend({
  props: {
    channel: {
      type: Object as PropType<ChannelListMessageChannel>,
      required: true
    },
    favoritedChannelIds: {
      type: Array as PropType<number[]>,
      default: () => []
    }
  },
  computed: {
    badgeCssClasses() {
      const classes = ['badge']
      const layouts = chatLayouts
      const layoutIndex = this.$store.state.messenger.layout.selectedLayoutIndex

      if (!layouts[layoutIndex]) {
        return classes
      }

      const numColumnsAvailable = layouts[layoutIndex].columns.length

      if (!numColumnsAvailable) {
        return classes
      }

      classes.push('pull-' + numColumnsAvailable)

      return classes
    },
    availableColumns() {
      const layouts = chatLayouts
      const layoutIndex = this.$store.state.messenger.layout.selectedLayoutIndex

      if (!layouts[layoutIndex]) {
        return []
      }

      const result: number[] = []
      for (let i = layouts[layoutIndex].columns.length; i > 0; i--) {
        result.push(i - 1)
      }

      return result
    },
    isFavorite(): boolean {
      if (!this.favoritedChannelIds) return false
      return this.favoritedChannelIds.includes(this.channel.id)
    }
  }
})
